<template>
<div>
	<form @submit.prevent="validateBeforeSubmit">
		<div class="form-group row">
			<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Descrição:</label>
			<div class="col-sm-10">
				<input type="text"
						name="descricao"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('descricao')}"
						v-model="form.descricao"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</span>
			</div>
		</div>

		<div class="form-group row">
			<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Tipo:</label>
			<div class="col-sm-10">
				<select name="tipo"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('tipo')}"
						v-model="form.tipo"
						class="form-control form-control-sm">
					<option value="">ESCOLHA</option>
					<option value="C">CÉLULA</option>
					<option value="M">MOTOR</option>
					<option value="H">HÉLICE</option>
				</select>
				<span  class="invalid-feedback" v-show="errors.has('tipo')">{{ errors.first('tipo') }}</span>
			</div>
		</div>

		<hr />

		<div class="row">
			<div class="col-sm-12 text-right">
				<small class="float-left text-info"><fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.</small>
				<button class="btn btn-success btn-sm">
					<fa-icon icon="check" transform="left-3" /> SALVAR
				</button>
			</div>
		</div>
	</form>
</div>
</template>

<script>
import axios from '../../../routers/axios'
export default {

    data(){
        return {
            form: {
                id: 0,
				descricao: "",
				tipo: "",
            }
        }
    },

    mounted () {
    },

    methods: {

        editar (item) {
            this.form.id = item.id
            this.form.descricao = item.descricao
            this.form.tipo = item.tipo
        },

        validateBeforeSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.salva();
                }
            });
        },

        salva(){

            var data = {
                id: this.form.id,
				descricao: this.form.descricao,
				tipo: this.form.tipo
            }

            this.$notify.loadIn('Salvando')

            if(this.form.id != 0){

                axios.put(this._getUrl('api/fabricante') + '/' + this.form.id, data).then(response => {
                    this.$emit('item-salvo', response.data)
                })

            } else {

                axios.post(this._getUrl('api/fabricante'), data).then(response => {
                    this.form.id = response.data.id
                    this.$emit('item-salvo', response.data)
                })
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/views/followair/fabricante/cadastro.vue